import { render, staticRenderFns } from "./AlertItinerary.vue?vue&type=template&id=618f85f6"
import script from "./AlertItinerary.vue?vue&type=script&lang=js"
export * from "./AlertItinerary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports